(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("wafer", [], factory);
	else if(typeof exports === 'object')
		exports["wafer"] = factory();
	else
		root["wafer"] = factory();
})(self, function() {
return 